import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const AxixBankBikeloanEmi   = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the Axis Bank Bike Loan EMI Calculator?",
            "answer": "It’s a tool to compute monthly EMIs based on loan amount, interest rate, and tenure."
          },
          {
            "question": "Is this calculator specific to Axis Bank loans?",
            "answer": "Yes, it’s optimized for Axis Bank’s typical bike loan parameters and interest rates."
          },
          {
            "question": "Do I need to register to use this calculator?",
            "answer": "No registration or login is required. It’s free and accessible to all users."
          },
          {
            "question": "What loan amounts can I calculate with?",
            "answer": "You can calculate EMIs for any amount, typically ranging from ₹10,000 to ₹5,00,000."
          },
          {
            "question": "How accurate are the EMI results?",
            "answer": "The calculator gives very accurate results based on your inputs, though final EMIs may vary slightly due to rounding or additional fees."
          },
          {
            "question": "Can I change the interest rate manually?",
            "answer": "Yes, you can adjust the interest rate to see how it affects your EMI."
          },
          {
            "question": "Does it show a complete repayment schedule?",
            "answer": "Yes, you can view a detailed amortisation schedule for the entire loan tenure."
          },
          {
            "question": "Is the amortisation schedule downloadable?",
            "answer": "You can copy and save the schedule manually or take screenshots for reference."
          },
          {
            "question": "Can it help in comparing different loan plans?",
            "answer": "Absolutely. Use it to test different loan amounts, rates, and tenures to compare EMIs."
          },
          {
            "question": "Does it account for prepayments?",
            "answer": "Not directly, but you can recalculate your EMI based on the reduced balance."
          },
          {
            "question": "What’s the benefit of a longer tenure?",
            "answer": "Lower EMIs, though you’ll end up paying more in interest overall."
          },
          {
            "question": "What documents are needed for Axis Bank’s bike loan?",
            "answer": "Usually, ID proof, address proof, income proof, bank statements, and photographs."
          },
          {
            "question": "Can I foreclose the bike loan early?",
            "answer": "Yes, but check Axis Bank’s foreclosure policy for any applicable charges."
          },
          {
            "question": "What’s the minimum CIBIL score for a bike loan?",
            "answer": "While it varies, a score above 700 improves your approval chances and interest rates."
          },
          {
            "question": "Where can I apply for an Axis Bank bike loan?",
            "answer": "You can apply via Axis Bank branches, their official website, or authorized dealers."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         {/* <title>Gold Loan EMI Calculator: Online Gold Loan EMI Calculator For - TheFinmaster</title>
        <meta  name='description' content='Home Loan EMI Calculator helps you calculate EMI of your housing loan required to pay for your dream home. Know about Online Home Loan EMI Calculator here! | TheFinmaster'/>
        <meta name='keywords' content='car loan emi calculator, car emi calculator, auto emi calculator, vehicle emi calculator, car finance emi calculator, automobile loan emi calculator, monthly emi calculator car loan' /> */}
        {/* <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/car-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" /> */}
      </Helmet>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Axis Bike Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
      <h1 className="text-2xl font-bold mb-4">Axis Bike Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your Axis Bank Bike Loan Payments with TheFinMaster’s EMI Calculator
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Buying a two-wheeler is a milestone for many, offering freedom, convenience, and mobility. Axis Bank, one of India’s leading private sector banks, provides competitive bike loan options to help make this dream a reality. To manage your loan smartly and ensure financial readiness, TheFinMaster presents the Axis Bank Bike Loan EMI Calculator—a comprehensive tool designed to give you instant, accurate EMI estimates based on your preferred loan amount, interest rate, and tenure. Whether you're budgeting your monthly expenses or comparing different loan scenarios, our calculator empowers you with financial clarity.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Bike Loan EMI?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Bike Loan EMI (Equated Monthly Instalment) is the fixed monthly amount you repay to the lender to cover your borrowed bike loan. It includes both the principal and interest components, calculated in a way that spreads the entire repayment over a specified loan tenure. The EMI ensures structured and convenient repayments while keeping your cash flow predictable. It allows you to enjoy your new bike without facing financial strain, as the cost is split across manageable monthly payments.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Axis Bank Bike Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Axis Bank Bike Loan EMI Calculator by TheFinMaster is a dynamic and easy-to-use digital tool that enables you to compute your monthly EMI with just a few inputs. Designed specifically for Axis Bank’s bike loan schemes, this calculator uses key financial metrics to deliver accurate projections of your monthly outflow. Whether you’re considering a short-term or long-term loan, the calculator helps you make informed decisions by showing how different interest rates and tenures impact your EMI.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              With the Axis Bank Bike Loan EMI Calculator, you eliminate guesswork, save time, and gain complete financial transparency before committing to a loan.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Axis Bank Bike Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Quick & Easy Calculations:</strong> Just enter the loan amount, interest rate, and tenure to get instant EMI results.</li>
                <li><strong>Tailored to Axis Bank:</strong> The calculator factors in typical rates and schemes from Axis Bank for more accurate outcomes.</li>
                <li><strong>Budget Planning:</strong> It allows you to estimate your monthly financial commitment and adjust loan terms accordingly.</li>
                <li><strong>Comparison Tool:</strong> Easily compare different scenarios—vary interest rates or loan amounts to find the best option.</li>
                <li><strong>Saves Time:</strong> No need to manually crunch numbers or use complex formulas.</li>
                <li><strong>Free & Accessible:</strong> Completely free to use with no hidden fees or login requirements.</li>
                <li><strong>Visual Insights:</strong> Often paired with amortisation tables for a month-wise payment breakdown.</li>
              </ul>
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Axis Bank Bike Loan EMI Calculator Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The EMI calculator functions based on the following standard formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Principal loan amount</li>
              <li>R = Monthly interest rate (Annual Rate / 12 / 100)</li>
              <li>N = Loan tenure in months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example Calculation:</strong><br />
              Let’s say you take a loan of ₹1,00,000 from Axis Bank at an annual interest rate of 10% for 12 months.<br />
              Monthly Interest Rate (R) = 10 / 12 / 100 = 0.00833<br />
              N = 12 months<br />
              Using the formula, your EMI would be approximately ₹8,791 per month.<br />
              This estimate helps you prepare for monthly obligations and plan your finances accordingly.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a month-by-month breakdown showing how your EMI is split into principal and interest components. It gives a detailed timeline of how your loan is repaid and helps you understand how much interest you’re paying over time. This is especially useful for budgeting and early repayment planning.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Sample 12-Month Amortisation Schedule for ₹1,00,000 at 10% Interest:</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Outstanding (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,057</td>
                    <td className="border px-4 py-2">734</td>
                    <td className="border px-4 py-2">91,943</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,123</td>
                    <td className="border px-4 py-2">668</td>
                    <td className="border px-4 py-2">83,820</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,190</td>
                    <td className="border px-4 py-2">601</td>
                    <td className="border px-4 py-2">75,630</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,257</td>
                    <td className="border px-4 py-2">534</td>
                    <td className="border px-4 py-2">67,373</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,325</td>
                    <td className="border px-4 py-2">466</td>
                    <td className="border px-4 py-2">59,048</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,392</td>
                    <td className="border px-4 py-2">399</td>
                    <td className="border px-4 py-2">50,656</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,460</td>
                    <td className="border px-4 py-2">331</td>
                    <td className="border px-4 py-2">42,196</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,528</td>
                    <td className="border px-4 py-2">263</td>
                    <td className="border px-4 py-2">33,668</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,596</td>
                    <td className="border px-4 py-2">195</td>
                    <td className="border px-4 py-2">25,072</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,665</td>
                    <td className="border px-4 py-2">126</td>
                    <td className="border px-4 py-2">16,407</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">8,734</td>
                    <td className="border px-4 py-2">57</td>
                    <td className="border px-4 py-2">7,673</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">8,791</td>
                    <td className="border px-4 py-2">7,673</td>
                    <td className="border px-4 py-2">0</td>
                    <td className="border px-4 py-2">0</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Principal  (₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left">Outstanding  (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
          ["1", "₹8,791", "₹8,057", "₹734", "₹91,943"],
          ["2", "₹8,791", "₹8,123", "₹668", "₹83,820"],
          ["3", "₹8,791", "₹8,190", "₹601", "₹75,630"],
          ["4", "₹8,791", "₹8,257", "₹534", "₹67,373"],
          ["5", "₹8,791", "₹8,325", "₹466", "₹59,048"],
          ["6", "₹8,791", "₹8,392", "₹399", "₹50,656"],
          ["7", "₹8,791", "₹8,460", "₹331", "₹42,196"],
          ["8", "₹8,791", "₹8,528", "₹263", "₹33,668"],
          ["9", "₹8,791", "₹8,596", "₹195", "₹25,072"],
          ["10", "₹8,791", "₹8,665", "₹126", "₹16,407"],
          ["11", "₹8,791", "₹8,734", "₹57", "₹7,673"],
          ["12", "₹8,791", "₹7,673", "₹0", "₹0"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
              ["1", "₹8,791", "₹8,057", "₹734", "₹91,943"],
              ["2", "₹8,791", "₹8,123", "₹668", "₹83,820"],
              ["3", "₹8,791", "₹8,190", "₹601", "₹75,630"],
              ["4", "₹8,791", "₹8,257", "₹534", "₹67,373"],
              ["5", "₹8,791", "₹8,325", "₹466", "₹59,048"],
              ["6", "₹8,791", "₹8,392", "₹399", "₹50,656"],
              ["7", "₹8,791", "₹8,460", "₹331", "₹42,196"],
              ["8", "₹8,791", "₹8,528", "₹263", "₹33,668"],
              ["9", "₹8,791", "₹8,596", "₹195", "₹25,072"],
              ["10", "₹8,791", "₹8,665", "₹126", "₹16,407"],
              ["11", "₹8,791", "₹8,734", "₹57", "₹7,673"],
              ["12", "₹8,791", "₹7,673", "₹0", "₹0"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold"> Principal  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Interest (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Bike Loan EMI
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> A higher loan amount leads to a bigger EMI since you're repaying a larger principal over time.</li>
                <li><strong>Interest Rate:</strong> Even a slight change in interest rate can greatly affect your EMI and total repayment.</li>
                <li><strong>Loan Tenure:</strong> Longer tenures reduce EMI amounts but increase total interest paid over the loan period.</li>
                <li><strong>Processing Fees:</strong> These one-time charges increase the upfront cost and may impact your loan planning.</li>
                <li><strong>Prepayments and Foreclosure:</strong> Making early payments or closing the loan ahead of schedule can lower interest outgo.</li>
                <li><strong>Credit Profile and CIBIL Score:</strong> A strong credit score can help secure lower interest rates and better loan terms.</li>
                <li><strong>Income and Employment Stability:</strong> Higher and stable income improves loan eligibility and influences EMI affordability.</li>
              </ul>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default AxixBankBikeloanEmi ;
